import React, { useEffect } from 'react';
import './WelcomeMessage.css';

const WelcomeMessage = ({ displayName, onDismiss, autoHide = true }) => {
  useEffect(() => {
    if (autoHide) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [autoHide, onDismiss]);

  return (
    <div className="welcome-overlay">
      <div className="welcome-card">
        <div className="welcome-animation">
          <div className="cosmic-circle">
            <span className="welcome-emoji">🚀</span>
          </div>
        </div>
        
        <div className="welcome-content">
          <h2 className="welcome-title">Welcome back to the cosmos!</h2>
          <p className="welcome-message">
            👋 Hey <span className="display-name">{displayName}</span>! 
            Ready to beam your thoughts to the universe?
          </p>
          
          <div className="welcome-actions">
            <button 
              className="start-posting-btn"
              onClick={onDismiss}
            >
              🌌 Start Posting
            </button>
          </div>
        </div>
        
        <div className="cosmic-particles">
          <span className="particle">✨</span>
          <span className="particle">🌟</span>
          <span className="particle">💫</span>
          <span className="particle">⭐</span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
